import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  ActionType,
  ListAction,
  ListConfig,
} from 'libs/core/shared-ui/src/lib/list/list.config';
import { Subscription } from 'rxjs';
import { areArraysEqual } from '@kodit/core/shared';
import {
  IRelevantniDokumentListItemUrlDto,
  FileType,
  RacuniClient,
  RelevantniDokumentListItemUrlDto,
  SefClient,
  SyncStatusPojedinacnogIzlaznihRacunaCommand,
  TipRelevantnogDokumenta,
} from '@kodit/core/data-api';
import { AlertService, SharedService } from '@kodit/core/services';
import { RacunInfoService } from '../racun-info/racun-info.service';
import {
  DynamicDialogConfig,
  DynamicDialogService,
} from '@kodit/core/shared-ui';
import { DialogSize } from 'libs/core/shared-ui/src/lib/dialogs/dynamic-dialog/dynamicdialog-config';
import { DocumentPreviewService } from '../../../../../../services/src/lib/document-preview.service';

@Component({
  selector: 'kodit-relevantni-dokumenti-po-racunu',
  templateUrl: './relevantni-dokumenti-po-racunu.component.html',
  styleUrls: ['./relevantni-dokumenti-po-racunu.component.scss'],
})
export class RelevantniDokumentiPoRacunuComponent
  implements OnInit, OnDestroy, OnChanges {
  /** Configurations */
  dialogConfig: DynamicDialogConfig = new DynamicDialogConfig(
    DialogSize.MEDIUM
  );

  /** Subscriptions */
  private _subs: Subscription = new Subscription();

  /** Props */
  listConfig: ListConfig;
  maxRows: number = 5;
  racunId: number;
  tipRelevantnogDokumenta: TipRelevantnogDokumenta =
    TipRelevantnogDokumenta.FAKTURA_US;

  /** I/O */
  @Input() showSyncBtn = false;
  @Input() btnLabel: string = '';
  @Input() createIcon: string = 'fa-light fa-rotate';
  @Input() shouldLoad: boolean;
  @Input() dokumentList: IRelevantniDokumentListItemUrlDto[] = [];
  @Input() title: string = 'Relevantni dokumenti';
  @Input() showPaginator: boolean;
  @Input() shouldDisableDownloadUbl: boolean;
  @Input() shouldDisplayDownloadUbl: boolean;
  @Output() downloadUblClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private _sharedService: SharedService,
    private _sefClient: SefClient,
    private _racunService: RacunInfoService,
    private _alertService: AlertService,
    private _racunClient: RacuniClient,
    private _dialogService: DynamicDialogService,
    private _docPreviewService: DocumentPreviewService,
  ) {
    this.listConfig = new ListConfig();
  }

  ngOnInit(): void {
    this._racunService.getRacunId.subscribe((res) => {
      this.racunId = res;
    });

    this.setListConfig();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !areArraysEqual(
        changes.dokumentList.currentValue,
        changes.dokumentList.previousValue
      )
    ) {
      this.dokumentList = changes.dokumentList.currentValue;
    }
  }

  setListConfig() {
    this.listConfig = {
      title: 'Relevantni dokumenti',
      paginator: true,
      rows: '5',
      toggleable: true,
      collapsed: true,
      deleteMessage: 'Da li ste sigurni da želite da obrišete dokument?',
      actions: this._getActions(),
      createCallbackFunction: () => this._onAdd(),
    };
  }

  handlePreview(item: RelevantniDokumentListItemUrlDto) {
    this._getDocument(item.storageFileName, false);
  }

  handleDownload(item: RelevantniDokumentListItemUrlDto) {
    if (item.fileType !== FileType.APPLICATION_PDF) {
      alert('Tip fajla nije podržan za preuzimanje');
      return;
    }
    this._getDocument(item.storageFileName, true);
  }

  onDownloadUblClicked() {
    this.downloadUblClicked.emit();
  }

  onCreate() {
    if (this.racunId) {
      this._subs.add(
        this._sefClient
          .syncDocPojedinacnogIzlaznogRacuna({
            racunId: this.racunId,
          } as SyncStatusPojedinacnogIzlaznihRacunaCommand)
          .subscribe((res) => {
            this._racunService.setReloadDocuments = this.racunId;
            this._alertService.addSuccessMsg(
              'Sinhronizacija dokumenta je uspešna'
            );
          })
      );
    }
  }

  private _getActions(): ListAction[] {
    if (!this.showSyncBtn) {
      return [];
    }
    return [
      new ListAction({
        type: ActionType.EDIT,
        //config: this.getEditListConfig(),
        callback: (index: number) => {
          // this.onEdit(index);
        },
      }),
      new ListAction({
        type: ActionType.DELETE,
        //config: this.getDeleteListConfig(),
        callback: (index: number) => {
          // this.onDelete(index);
        },
      }),
    ];
  }

  private _getDocument(storageFileName: string, isDownload: boolean) {
    if (isDownload) {
      this._subs.add(
        this._racunClient
          .getRelevantniDokument(storageFileName)
          .subscribe((res) => {
            const blobUrl = URL.createObjectURL(res.data);
            this._sharedService.downloadUrlAsPDF(blobUrl, res.fileName);
          })
      );
    } else {
      this._subs.add(
        this._racunClient
          .getRelevantniDokumentUrl(storageFileName)
          .subscribe((res) => {
            this._docPreviewService.openDialogForPresignedUrl(res.data.fileUrl);
          })
      );
    }
  }

  private _onAdd() {
    alert('ToDo');
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
